import { useEffect, useState } from 'react';

// "controllers"
import { UserController } from 'controllers';

// components
import { Carousel, CarouselImage } from 'shared/components/bulma/carousel';

const InspirationalPhotos = ({ id, customer }) => {
    const [images, setImages] = useState([]);

    useEffect(() => {
        const getPhotos = async () => {
            const data = await UserController.getUserCollection(customer.id, 'photos');
            setImages(data);
        }

        if (customer?.id) {
            getPhotos();
        }
    }, [id, customer]);

    if (!images.length) {
        return (
            <div className="container">
                No images found!
            </div>
        )
    }

    return (
        <Carousel id={id}>
            {images.map((image) => (
                <CarouselImage key={image.id} imgSrc={image.photoURL} className="is-1by1" />
            ))}
        </Carousel>
    );
};

export { InspirationalPhotos };
